<nz-form-label class="lbl-label" nzNoColon [ngClass]="className">{{display()}}</nz-form-label>